import { render, staticRenderFns } from "./bankinformation.vue?vue&type=template&id=68057fbb&scoped=true"
import script from "./bankinformation.vue?vue&type=script&lang=js"
export * from "./bankinformation.vue?vue&type=script&lang=js"
import style0 from "./bankinformation.vue?vue&type=style&index=0&id=68057fbb&prod&lang=scss&scoped=true"
import style1 from "./bankinformation.vue?vue&type=style&index=1&id=68057fbb&prod&lang=css"
import style2 from "./bankinformation.vue?vue&type=style&index=2&id=68057fbb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68057fbb",
  null
  
)

export default component.exports